import { Observable } from '@helpcenter/epics-rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { fetchArticleSpaceKey } from 'rest/fetch-article-space-key';
import type {
    FetchArticleSpaceKeyAction,
    FetchArticleSpaceKeyFailureAction,
    FetchArticleSpaceKeySuccessAction,
} from 'state/actions/article';
import {
    FETCH_ARTICLE_SPACE_KEY,
    fetchArticleSpaceKeySuccess,
    fetchArticleSpaceKeyFailure,
} from 'state/actions/article';
import { sendEvent } from '@atlassian/help-center-common-util/analytics';
import { isNetworkOrClientErrorCode } from '@atlassian/help-center-common-util/error-codes';
import type { ErrorResponse } from 'epics/model/types';

export const fetchSpaceKeyEpic: Epic<
    FetchArticleSpaceKeyAction,
    FetchArticleSpaceKeySuccessAction | FetchArticleSpaceKeyFailureAction
> = (action$) => {
    return action$.ofType(FETCH_ARTICLE_SPACE_KEY).mergeMap((action) => {
        const { meta } = action;
        return fetchArticleSpaceKey({ articleId: action.payload.articleId })
            .map((response) => {
                if (meta?.analyticsSuccessEvent) {
                    sendEvent(meta.analyticsSuccessEvent);
                }
                return fetchArticleSpaceKeySuccess(response);
            })
            .catch((error: ErrorResponse) => {
                if (meta?.analyticsFailureEvent && !isNetworkOrClientErrorCode(error.status)) {
                    sendEvent(meta.analyticsFailureEvent);
                }
                return Observable.of(fetchArticleSpaceKeyFailure(action.payload.articleId, error));
            });
    });
};
